export const SITE_URL = 'https://michaelabraun.de';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/img/michaela_about.png`;
